module.exports = __webpack_public_path__ + "585dc590a37b862ac507c0b66c0c48ed.svg";